import config from '../config';


export function getHashParams() {
    let hashParams = {};
    let e,
        a = /\+/g, // Regex for replacing addition symbol with a space
        r = /([^&;=]+)=?([^&;]*)/g,
        d = (s) => { return decodeURIComponent(s.replace(a, " ")) },
        q = window.location.hash.substring(1);
    while(e === r.exec(q))
     hashParams[d(e[1])] = d(e[2]);
    return hashParams;
};

export function payoutWinToProb(payout) {
    console.assert(typeof payout === 'number');
    console.assert(payout >= 0);
    let n = 1.0 - config.house_edge;

    return n / payout;
};


// WEBPACK FOOTER //
// ./src/helpers/index.js